<template>
  <b-modal
    centered
    :visible="show"
    hide-footer
    hide-header
    no-close-on-backdrop
    no-close-on-esc
  >
    <b-container>
      <b-row>
        <b-col>
          <h4 class="text-info m-2">{{ $t("globals.add_devices_from_stock") }}:</h4>
        </b-col>
      </b-row>
      <hr>
      <b-row>
        <b-col>
          <b-form-file
            v-model="file"
            accept=".csv"
            :state="Boolean(file)"
            placeholder="Choose a file or drop it here..."
            drop-placeholder="Drop file here..."
          ></b-form-file>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-checkbox
            class="m-1"
            v-model="sold"
            :value="true"
            :unchecked-value="false"
            :state="sold ? sold : null"
          >
            {{ $t("globals.add_a_sold_event_for_these_devices") }}
          </b-form-checkbox>
        </b-col>
      </b-row>
      <b-row v-if="sold">
        <b-col cols="12">
          <b-form-checkbox
            class="m-1"
            v-model="sold_lease"
            :value="true"
            :unchecked-value="false"
          >
            {{ $t("globals.lease") }}
          </b-form-checkbox>
        </b-col>
        <b-col cols="12">
          <span>{{ $t("globals.sold_at") }}:</span>
          <b-form-datepicker 
            :state="true"
            v-model="sold_at"
          ></b-form-datepicker>
        </b-col>
        <b-col
          v-if="getUserBrandPermissions.create_device_event_custom_agent"
          cols="12"
        >
          <span v-b-tooltip.hover title="Optional, if left empty, you will be assigned" >
            {{ "*" + $t("globals.select_agent") }}:
          </span>
          <b-form-select
            class="m-1"
            v-model="new_agent_id"
            :options="agentOptions"
          />
        </b-col>
      </b-row>
      <hr />
      <b-row>
        <b-col>
          <b-btn
            size="sm"
            @click="cancel"
            variant="warning"
          >
            {{ $t("globals.cancel") }}
          </b-btn>
        </b-col>
        <b-col>
          <b-btn
            class="float-right"
            size="sm"
            variant="success"
            @click="submitFile"
            :disabled="uploadDisabled"
          >
            {{ $t("globals.submit") }}
          </b-btn>
        </b-col>
      </b-row>
    </b-container>
  </b-modal>
</template>

<script>
import { mapActions, mapMutations, mapGetters } from "vuex";
import { currencyFormat } from "@/helpers/price";

export default {
  props: {
    show: Boolean,
    close: Function
  },
  data() {
    return {
      file: "",
      sold: true,
      sold_lease: false,
      sold_at: "",
      new_agent_id: null,
      agentOptions: []
    };
  },
  methods: {
    ...mapMutations(["setShowLoadingModal"]),
    ...mapActions("axios_mod", ["simpleMutation", "simpleFetch"]),
    currencyFormat,
    cancel() {
      this.file = "";
      this.sold = false;
      this.sold_lease = false;
      this.new_agent_id = null;

      this.setToday();
      this.close();
    },
    submitFile() {
      this.getBase64(this.file).then(data64 => {
        let data = {
          query: `
            mutation DevicesAssignToOrder (
              $base_64: Boolean,
              $device_list: [String],
              $order_id: Int,
              $sold: Boolean,
              $sold_lease: Boolean,
              $sold_at: String,
              $agent_id: ID
            ) { 
              res: DevicesAssignToOrder (
                base_64: $base_64
                device_list: $device_list,
                order_id: $order_id,
                sold: $sold,
                sold_lease: $sold_lease,
                sold_at: $sold_at,
                agent_id: $agent_id
              )
            }
          `,
          variables: {
            base_64: true,
            device_list: [data64],
            order_id: parseInt(this.$route.params.id),
            sold: this.sold,
            sold_lease: this.sold_lease,
            sold_at: this.sold_at,
            agent_id: this.new_agent_id
          }
        };

        this.simpleMutation({ data, this_ref: this }).then(() => {
          this.cancel();
        });
      });
    },
    getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
      });
    },
    fetchAgents() {
      const data = {
        query: `
          query  {
            allAgents {
              value: id
              text: full_name
            }
          }
        `
      };
      this.setShowLoadingModal(true);
      this.simpleFetch({ data, this_ref: this })
        .then(res => {
          if (res) {
            this.agentOptions = res.allAgents
          }
        })
        .finally(() => {
          this.setShowLoadingModal(false);
        });
    },
    setToday() {
      const now = new Date;
      this.sold_at = now.toISOString().substring(0,10);
    }
  },
  computed: {
    ...mapGetters(["getUserBrandPermissions"]),
    uploadDisabled() {
      return this.file === ""
    }
  },
  mounted() {
    this.setToday();
    this.fetchAgents();
  }
};
</script>
